import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '../../../../../utils/components/Button/Button'
import Input from '../../../../../utils/components/Input/Input'
import InputSearch from '../../../../../utils/components/InputSearch/InputSearch'
import useModal from '../../../../../utils/hooks/useModal'
import { deleteProduct } from '../../../../actions/productActions'
import { Table } from '../../../../components/Table/Table'
import ReportModal from './ReportModal'
import style from './ProductList.module.css'
const ProductList = ({
    products,
    searchAction,
    presentations,
    presentation,
    setPresentation,
    reportType,
    setReportType,
    reportInitialDate,
    setReportInitialDate,
    reportEndDate,
    setReportEndDate,
    utilityReport,
    reportByType }) => {

    const [refReport, isReportShow, setIsReportShow] = useModal(false);
    const [ref, isShow, setIsShow] = useModal(false);
    const history = useHistory();
    const [product, setProduct] = useState(null);
    return (
        <div>
            <div className={style.inputSearch_container}>
                <div className={style.buttons_container}>
                    <Button
                        classNameContent={style.button__margin}
                        text='Crear Producto'
                        onClick={() => {
                            history.push('/Admin/Inventory/products/Create')
                        }}
                    />
                    <Button
                        classNameContent={style.button__margin}
                        text='Categorías'
                        onClick={() => {
                            history.push('/Admin/Inventory/Categories')
                        }}
                    />
                    <Button
                        classNameContent={style.button__margin}
                        text='Presentaciones'
                        onClick={() => {
                            history.push('/Admin/Inventory/Presentations')
                        }}
                    />
                    <Button
                        classNameContent={style.button__margin}
                        text='Reporte'
                        onClick={() => {
                            setIsReportShow(true)
                        }}
                    />
                </div>
                <InputSearch searchData={(value) => searchAction(value)} placeholder='Buscar por nombre' classNameContent={style.inputSearch} isDrowMenu={false} />
                <div>

                    <select value={presentation} onChange={e => setPresentation(e.target.value)}>
                        <option value={""}>Filtrar por presentación</option>
                        {
                            presentations.map(presentation => (
                                <option key={presentation._id} value={presentation._id}>{presentation.name}</option>
                            ))
                        }
                    </select>
                </div>

            </div>
            <Table>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Categoría</th>
                        <th>Sub categoría</th>
                        <th>Acciones</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        products.map(product => (
                            <tr key={product._id}>
                                <td>{product.code}</td>
                                <td>{product.name}</td>
                                <td>{product.categoryId.name}</td>
                                <td>{product.subcategoryId.name}</td>
                                <td>
                                    <div className='column spaceAround'>
                                        <Button text='Editar' onClick={() => {
                                            history.push(`/Admin/Inventory/products/${product._id}/Edit`)
                                        }} />
                                        <Button text='Borrar' onClick={() => {
                                            setProduct(product)
                                            setIsShow(true)
                                        }} />
                                    </div>
                                </td>
                            </tr>
                        ))
                    }

                </tbody>
            </Table>
            <Modal
                product={product}
                closeModal={() => { setIsShow(false) }}
                displayModal={isShow} />
            <ReportModal
                closeModal={() => { setIsReportShow(false) }}
                displayModal={isReportShow}
                reportType={reportType}
                setReportType={setReportType}
                reportInitialDate={reportInitialDate}
                setReportInitialDate={setReportInitialDate}
                reportEndDate={reportEndDate}
                setReportEndDate={setReportEndDate}
                utilityReport={utilityReport}
                reportByType={reportByType}
            />

        </div>
    )
}

const Modal = ({ closeModal, displayModal, product }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(e)
    }
    const [reasonForDeletion, setReasonForDeletion] = useState("")

    const dispatch = useDispatch();

    if (!product) return <></>
    return <div
        className={"modal"}
        style={divStyle}
        onClick={close}>
        <div
            className="modal-content modal-content-new-post"
            onClick={e => e.stopPropagation()} >
            Introduzca la razón para que el producto: {product.name} sea eliminado
            <Input onChange={(e) => setReasonForDeletion(e.target.value)}

            />
            <div className='column centerItems'>
                <Button disabled={reasonForDeletion.length <= 3} text='Si' onClick={(e) => {
                    dispatch(deleteProduct(product._id, reasonForDeletion, () => { close(e) }))
                }} />
                <Button text='No' onClick={(e) => {
                    close(e)
                }} />
            </div>
        </div>


    </div>
}

export default ProductList